import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import { fill } from './fill';
import './sharing.css';

interface ConflictDialogProps {
  /** Who saved the version we would be writing over */
  lastEditedBy: string;
  busy?: boolean;
  onLoadTheirs: () => void;
  onKeepMine: () => void;
}

// Shown when a save came back 409: someone else saved while this person was
// writing. Both ways out are theirs to choose — nothing is decided for them,
// and their text stays in the editor until they say otherwise.
const ConflictDialog: React.FC<ConflictDialogProps> = ({
  lastEditedBy, busy = false, onLoadTheirs, onKeepMine,
}) => {
  const { t } = useLanguage();

  return (
    <div className="conflict-overlay">
      <div className="conflict-dialog" role="alertdialog" aria-modal="true">
        <h2>{t.sharing.conflictTitle}</h2>
        <p className="conflict-body">{fill(t.sharing.conflictBody, { name: lastEditedBy })}</p>
        <p className="conflict-warning">{t.sharing.conflictWarning}</p>
        <div className="conflict-actions">
          <button type="button" className="conflict-theirs" disabled={busy} onClick={onLoadTheirs}>
            {t.sharing.conflictLoadTheirs}
          </button>
          <button type="button" className="conflict-mine" disabled={busy} onClick={onKeepMine}>
            {t.sharing.conflictKeepMine}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConflictDialog;
